import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class ModuleAcceessService {
    modules = [
        
        {
            name: "VideoListing",
            menuName: "Matches",
            class: "fa fa-futbol",
            parentRoute: "/main/matches",
            menu: false,
            submenu: []
        },
        {
            name: "Player",
            menuName: "Players",
            class: "fa fa-user",
            parentRoute: "/main/players",
            menu: false,
            submenu: []
        },
        {
            name: "Team",
            menuName: "Teams",
            class: "fa fa-users",
            parentRoute: "/main/teams",
            menu: false,
            submenu: []
        },
          {
            name: "League",
            menuName: "Leagues",
            class: "fa fa-trophy",
            parentRoute: "/main/leagues",
            menu: false,
            submenu: []
        },
        {
            name: "Action",
            menuName: "Actions",
            class: "fa fa-video-camera",
            parentRoute: "/main/actions",
            menu: false,
            submenu: []
        },

        {
            name: "FilterPlayer",
            menuName: "Filtered Players",
            class: "fa fa-filter",
            parentRoute: "/main/filtered-players",
            menu: false,
            submenu: []
        },
        {
            name: "Stats",
            menuName: "Stats",
            class: "fa fa-line-chart",
            parentRoute: "/main/stats",
            menu: false,
            submenu: []
        },
        {
            name: "MetaDataUploader",
            menuName: "Manage Metadata",
            class: "fa fa-upload",
            parentRoute: "/main/meta-data",
            menu: false,
            submenu: []
        },
        {
            name: "setting",
            menuName: "Settings",
            class: "fa fa-cog",
            menu: false,
            submenu: [
                {
                    name: "Cache",
                    menuName: "Cache",
                    class: "fa fa-database",
                    route: "/main/settings",
                },
                {
                    name: "parserSetting",
                    menuName: "Parser",
                    class: "fa fa-file-text",
                    route: "/main/parser"
                },
                // {
                //     name: "system",
                //     menuName: "System",
                //     class: "fa fa-laptop",
                //     route: "/main/system"
                // }
            ]
        },


        {
            name: "Fixtures",
            menuName: "Fixtures",
            class: "fa fa-sitemap",
            parentRoute: "/main/fixtures",
            menu: false,
            submenu: []
        },
        {
            name: "AwsVideos",
            menuName: "Video Files",
            class: "fa fa-file-video",
            parentRoute: "/main/video-files",
            menu: false,
            submenu: []
        },
        {
            name: "AwsJobs",
            menuName: "Encoded Videos",
            class: "fa-brands fa-aws",
            parentRoute: "/main/encoded-videos",
            menu: false,
            submenu: []
        },
        {
            name: "SyncingTool",
            menuName: "Syncing Tool",
            class: "fa fa-code-fork",
            parentRoute: "/main/syncing-tool",
            menu: false,
            isHidden: true,
            submenu: []
        },
        {
            name: "MetaDataGenerator",
            menuName: "MetaData-Generator",
            class: "fa fa-file-code",
            parentRoute: "/main/meta-data/generate",
            menu: false,
            isHidden: true,
            submenu: []
        },
        {
            name: "XmlChecker",
            menuName: "XML-Checker",
            class: "fa fa-search-plus",
            parentRoute: "/main/xml-checker",
            menu: false,
            submenu: []
        },
        // {
        //     name: "API",
        //     menuName: "API",
        //     class: "fa fa-pie-chart",
        //     parentRoute: "/main/analytics",
        //     menu: false,
        //     submenu: []
        // },
        {
            name: "Analytics",
            menuName: "Analytics",
            class: "fa fa-bar-chart",
            menu: false,
            submenu: [
                {
                    name: "Summary",
                    menuName: "Summary",
                    class: "fa fa-tachometer",
                    route: "/main/analytics/dashboard",
                },
                {
                    name: "Audience",
                    menuName: "Audience",
                    class: "fa fa-users",
                    route: "/main/analytics/audience",
                },
              
            ]
        },
        {
            name: "ViberReport",
            menuName: "Viber Report",
            class: "fa fa-pie-chart",
            parentRoute: "/main/analytics/viber-report",
            menu: false,
            submenu: []
        },
        {
            name: "EmbedScript",
            menuName: "Vidgets",
            class: "fa fa-link",
            parentRoute: "/main/embed",
            menu: false,
            submenu: []
        },
        {
            name: "whitelistdomain",
            menuName: "Whitelist Domain",
            class: "fa fa-external-link",
            parentRoute: "/main/whitelist-domain",
            menu: false,
            submenu: []
        },
        {
            name: "ClubListing",
            menuName: "Clubs",
            class: "fa fa-gamepad",
            parentRoute: "/main/clubs",
            menu: false,
            submenu: []
        },
        {
            name: "User",
            menuName: "Users",
            class: "fa fa-user-secret",
            parentRoute: "/main/users",
            menu: false,
            submenu: []
        },

        {
            name: "Capabilities",
            menuName: "Permissions",
            class: "fa fa-user-shield",
            parentRoute: "/main/permissions",
            menu: false,
            submenu: []
        },

        {
            name: "Roles",
            menuName: "Roles",
            class: "fa fa-address-book",
            parentRoute: "/main/roles",
            menu: false,
            submenu: []
        },

        {
            name: "Faq",
            menuName: "FAQ",
            class: "fa fa-question",
            parentRoute: "/main/faq",
            menu: false,
            isHidden: true,
            submenu: []
        },
        {
            name: "Page",
            menuName: "Pages",
            class: "fa fa-file",
            parentRoute: "/main/pages",
            menu: false,
            isHidden: true,
            submenu: []
        }, 
        //  {
        //     name: "Page",
        //     menuName: "Pages",
        //     class: "fa fa-file",
        //     parentRoute: "/main/pages",
        //     menu: false,
        //     submenu: []
        // },
        {
            name: "vibermessenger",
            menuName: "Viber Messenger",
            class: "fa fa-bullhorn",
            parentRoute: "/main/viber-mesenger",
            menu: false,
            submenu: []
        },
        {
            name: "StaticPages",
            menuName: "Static Pages",
            class: "fa fa-file",
            parentRoute: "/main/pages",
            menu: false,
            submenu: []
        },
        {
            name: "Configuration",
            menuName: "Configurations",
            class: "fa fa-cogs",
            parentRoute: "/main/configurations",
            menu: false,
            submenu: []
        },
        // {
        //     name: "CustomVidgets",
        //     menuName: "Custom Vidgets",
        //     class: "fa fa-code",
        //     parentRoute: "/main/custom-widgets",
        //     menu: false,
        //     submenu: []
        // },
        {
            name: "VidgetWizard",
            menuName: "Vidget Wizard",
            class: "fa fa-bar-chart",
            menu: false,
            submenu: [
                {
                    name: "TemplateSelection",
                    menuName: "Template Selection",
                    class: "fa fa-link",
                    route: "/main/embed",
                },
                {
                    name: "VidgetLibrary",
                    menuName: "Vidget Library",
                    class: "fa fa-code",
                    route: "/main/vidget-library",
                },
                // {
                    // name: "SocialSetting",
                    // menuName: "Social Setting",
                    // class: "fa fa-users",
                    // route: "/main/embed",
                // },
              
            ]
        }
    ];
    constructor(private http: HttpClient) { }

    getModuleInfo() {
        return this.modules;
    }
}
